import React, { useEffect, useCallback, useState } from 'react';
import SliderHeader from 'jd-library/SliderHeader';
import historyHandler from 'jd-library/historyHandler';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import styles from './user_auth.scss';
import ListElem from './ListElem';
import VerifyUser from './VerifyUser';
import MsgComp from './MsgComp';
import ModalComp from './ModalComp';
import ConfirmModal from './ConfirmModal';
import axios from 'axios';
import { changeMobileNo, changeEmailIds, set, identifyAuditFlow, getPlatform } from '../../utills';
import {setLoggedUser, setSession} from '../../actions/index';
import Button from 'jd-library/Button';
import {toggleActionCardSlider, toggleTab} from '../../actions/products';
import queryString from 'query-string';
import {showToastMessage} from '../../actions/toastmessage';
import { hideProductEditSlider } from '../../actions/products';

const sendOtp = (options = {}) => {
    let {userName, key, cb, type, token, companyName, isIndex} = options;
    axios.get(`/vendor/manage-products-genio/${token}/api/sendOtp.ns?key=${key}&type=${type}&isIndex=${isIndex}`, {
		headers: {
			'userName': userName
		}
	}).then((data) => {
        cb && cb(data);
    });
};

const UserAuth = props => {
    let history = useHistory();
    const [verifyPg, setVerifyPg] = useState(false);
    const [verifyPgProps, setVerifyPgProps] = useState({});
    const [showMsg, setMsg] = useState(false);
    const [jdEmpPresent, setJdEmpPresent] = useState(false);
    const [empLogin, setEmpLogin] = useState(false);
    let userData = props.session.user.loginData;
    let user = props.session.user;
    const [mobileNos, setMobileNos] = useState([]);
    const [initialized, setInitialized] = useState(false);
    const [emailIds, setEmailIds] = useState([]);
    const [openModal, setModal] = useState(false);
    const [modalProps, setModalProps] = useState({});
    const [confirmModal, setConfirmModal] = useState(false);
    const [confirmProps, setConfirmProps] = useState({});
    let route = useLocation();
    let selectTypeQuery = identifyAuditFlow({ query: true });
    const [isTypeSelPage, updateTypeSelPage] = useState((route.pathname == "/products/login") ? false : true);
    const rippleColor = 'rgba(0,0,0,0.1)';
    const companyName = props.session.companyName;
    const [isScrolled, setScroll] = useState(
		typeof document === 'object' && document.scrollingElement.scrollTop > 0
	);
    const [isTestingContract, updateTestingContract] = useState(false);
    const dispatch = useDispatch()
    let isAutoLogin = false;
    let token;
    if(typeof window != "undefined" && window.location.search.indexOf("token=") > -1) {
        // let urlData = window.location.search.split('?');
        // token = urlData[1].split('=')[1];
        let url = window.location.search;
        let params = queryString.parse(url);
        token = params['token'];
		isAutoLogin = true;
    }
    if(!isAutoLogin && props.session.autoLogin) {
        isAutoLogin = true;
    }
    useEffect(() => {
        dispatch(toggleActionCardSlider({isActionCardSliderOpen: false}))
    }, [])
    useEffect(()=>{
        if(isAutoLogin && isTypeSelPage){
            updateTypeSelPage(false);
        }
    });
    useEffect(() => {
        if(userData) {
            if(empLogin) {
                setMobileNos([changeMobileNo(userData.employeeMobileList[0])]);
                setEmailIds([changeEmailIds(userData.employeeEmailList[0])]);
            } else {
                setMobileNos(userData.ownerMobileList);
                setEmailIds(userData.ownerEmailList);
            }
            setInitialized(true);
            if(userData.employeeMobileList.length || userData.employeeEmailList.length){
                setJdEmpPresent(true);
            }
        }
        if(props.session.user.loginData) {
            updateTestingContract(props.session.user.loginData.isTestingContract);
        }
    },[props.session.user.loginData]);

    useEffect(() => {
        if(props.session.user.loggedUser){
            let replaceUrl = selectTypeQuery.fromDiscount ? "/products/discount" :selectTypeQuery.fromInventory ?"/products/inventory": selectTypeQuery.fromOrderListing ? "/order" : "/products";
            history.replace(replaceUrl);
            return;
        }else {
            props.hideProductEditSlider();
        }
        window.addEventListener('scroll', handleScroll);
        return () => {
			window.removeEventListener('scroll', handleScroll);
		};
    },[jdEmpPresent])
    const handleScroll = useCallback(() => {
		setScroll(document.scrollingElement.scrollTop > 0);
    }, []);
    const isMobile = props.isMobile;
    let leftIconArr = [
		{
			className: 'icon-hdrBackNew',
			onClick: () => {
                history.goBack();
			}
		}
    ];
    let rightIconArr = [
		{
			className: 'icon-HDRcross',
			onClick: () => {
                history.goBack();
			}
		}
    ];
    if (route.pathname == "/products/login" && !user.noUserCheck) {
        leftIconArr = [];
        rightIconArr = [];
    }
    const openInputModal = (options = {}) => {
        let {type, key} = options;
        setModalProps({
            type: type,
            serviceKey: key,
            heading: (type == 'email') ? 'Enter Email' : 'Enter Mobile',
            placeHolder: (type == 'email') ? 'Email Id' : 'Mobile Number',
            onHidden:() => {
                setModal(false);
            },
            onSubmit:(mobOrEmail, type, key) => {
                onItemClick({
                    type: type,
                    data: mobOrEmail,
                    key: key, 
                    companyName,
                    calledFrom: "testing",
                    confirmed: true
                })
            }
        })
        setModal(true);
    }
    const onItemClick = (options = {}) => {
        let {type,data,index, key, companyName, confirmed, calledFrom} = options;
        if(!isAutoLogin && !confirmed){
            setConfirmProps({
                type: type,
                data: data,
                index,
                serviceKey: key,
                onHidden:() => {
                    setConfirmModal(false);
                },
                onConfirm: (confirmOptions = {}) => {
                    // setConfirmModal(false);
                    let {type,data, serviceKey, index} = confirmOptions;
                    onItemClick({
                        type: type,
                        data: data,
                        key: serviceKey, 
                        companyName,
                        index,
                        confirmed: true
                    })
                }
            });
            setConfirmModal(true);
            return;
        }
        if(!isTypeSelPage && !isAutoLogin) {
            if(empLogin){
                historyHandler.removeBackHandler("emp-login", closeEmpLogin);
            } else {
                historyHandler.removeBackHandler("user-login", closeUserLogin);
            }
        }
        let pgHeading;
        if(type == 'mobile'){
            pgHeading = 'Verify Mobile Number';
        }else{
            pgHeading = 'Verify Email';
        }
        let sendTestingParam = (calledFrom != 'testing' && isTestingContract);
        const platform = getPlatform();
        let temp = {
            heading: pgHeading,
            mobOrEmail: data,
            isEmail: (type == 'email'),
            onHidden: () => {
                if(!isAutoLogin){
                    if(empLogin){
                        historyHandler.addBackHandler("emp-login",closeEmpLogin);
                    } else {
                        historyHandler.addBackHandler("user-login", closeUserLogin);
                    }
                }
                setVerifyPg(false);
            },
            sendOtpApi: `/vendor/manage-products-genio/${props.session.token}/api/sendOtp.ns?key=${key}&type=${type}&companyName=${companyName}${sendTestingParam ? '&isIndex=true' : ''}`,
            verifyOtpApi: `/vendor/manage-products-genio/${props.session.token}/api/verifyOtp.ns`,
            platform,
            headersData: {userName: calledFrom == 'testing' ? data : index} 
        }
        if(isAutoLogin){
            // if(calledFrom != 'testing') {
            //     historyHandler.closeCurrent();
            // }
            //setConfirmModal(false);
            // temp.verifyOtpApi+=`?autoLoginToken=${token}&userName=${calledFrom == 'testing' ? data : index}`
            axios({
                url: temp.verifyOtpApi,
                method: 'POST',
                data:{
                    autoLoginToken:token,
                    userName:calledFrom == 'testing' ? data : index
                }
            }).then(data => {
                if(data && data.data && data.data.isSuccess){
                    props.toggleTab({isToggleTab: true});
                    props.setLoggedUser(data.data.prodCrudData);
                    props.setSession({
                        autoLogin: true
                    });
                    history.push(selectTypeQuery.fromDiscount ? "discount" :selectTypeQuery.fromInventory?"inventory": "/products");
                }else{
                    props.showToastMessage({
                        showToastMessage: true,
                        message: 'Something Went Wrong',
                        duration: 5000
                    });
                }
            })
        }
        else{
            sendOtp({
                userName: (calledFrom == 'testing') ? data : index,
                key,
                token: props.session.token,
                companyName,
                isIndex: sendTestingParam ? true : '',
                type,
                cb: (data) => {
                    // setConfirmModal(false);
                    if(calledFrom != 'testing') {
                        historyHandler.closeCurrent();
                    }
                    setTimeout(() => {
                        if(data.data.isSuccess){
                            setVerifyPgProps(temp);
                            setVerifyPg(true);
                        }else if(data.data.errorCode){
                            temp.failedCount = 5;
                            temp.heading = 'Verification Unsuccessful'
                            setVerifyPgProps(temp);
                            setVerifyPg(true);
                        }
                    },100);
                }
            });
        }
    }
    const closeEmpLogin = () => {
        setEmpLogin(false);
        setMobileNos(userData.ownerMobileList);
        setEmailIds(userData.ownerEmailList);
        updateTypeSelPage(true);
        historyHandler.removeBackHandler("emp-login", closeEmpLogin);
    }

    const closeUserLogin = () => {
        updateTypeSelPage(true);
        historyHandler.removeBackHandler("user-login", closeUserLogin);
    }
    const loginAsEmp = () => {
        setEmpLogin(true);
        setMobileNos([changeMobileNo(userData.employeeMobileList[0])]);
        setEmailIds([changeEmailIds(userData.employeeEmailList[0])]);
        if(isMobile){
            historyHandler.addBackHandler("emp-login",closeEmpLogin);
            historyHandler.pushState(history, "emp-login");
        }
    }
    const openMsgSlider = () => {
        setMsg(true);
    }
    let pageheading = 'Log In';
    if(!isTypeSelPage){
        if(empLogin){
            pageheading = 'Login as Justdial Representative';
        } else {
            pageheading = 'Log In as Business Owner';
        }
    }

    const openReadOnlyPage = () => {
        let url = window.location.href;
        url = url.replace('/auth', '');
        if(window.location.search){
            url = url + '&isReadOnly=1';
        }else{
            url = url + '?isReadOnly=1';
        }
        window.open(url, '_blank');
    }
    let subtext = "You need to authenticate yourself before you can make any changes in your product catalogue";
    let mobileHeaderIcon = 'icon-SMSlg';
    if(isAutoLogin){
        subtext = "Please select your mobile number from the following list to login";
        mobileHeaderIcon = "icon-GlMobile";
    }
    const hideView = showMsg || verifyPg;
	return (
		<>
            <SliderHeader
                className={styles['auth-header']}
                heading={props.session.companyName || 'Your Company'}
                leftIconArray={isMobile ? leftIconArr : []}
                leftIcons={isMobile ? leftIconArr : []}
                rightIconArray={isMobile ? [] : rightIconArr}
                rightIcons={isMobile ? [] : rightIconArr}
                variant='secondary'
                raised={isScrolled}
                hasBorder = {true}
                headingClass={styles['bold-txt']}
            />
            <div className={styles['auth-page']}>
                {hideView ? null : (
                    <>
                        <div className={styles['page-heading']}>{pageheading}</div>
                        <div className={styles['sub-txt']}>{subtext}</div>
                    </>
                )}
                {!isTypeSelPage && !hideView ? <>
                    {!isAutoLogin && (<div className={styles['section-title']}>Select a way to receive the OTP code</div>)}
                <div className={styles['block-container']+" "+(isAutoLogin ? styles['auto-block-container'] : '')}>
                    {mobileNos.length ? <div className={styles['block']}>
                    <div className={styles['heading']}>
                            <span className={mobileHeaderIcon+' heading-icon'}></span>
                            <span>{isAutoLogin ? "SELECT MOBILE NUMBER" : "SMS OTP TO"}</span>
                        </div>
                        <div className={styles['divider']+' '+styles['list-title-divider']}></div>
                        {mobileNos.map((mobile, index) => (
                            <ListElem content={mobile} onClick={() => onItemClick({
                                type:'mobile',
                                data: mobile, 
                                index, 
                                key: empLogin ? "employeeMobileList" : "ownerMobileList", 
                                companyName,
                                rippleColor: rippleColor
                            })}/>
                        ))}
                        {(!empLogin &&  !isAutoLogin) && <ListElem content='My mobile number is not present' onClick={openMsgSlider} rippleColor={rippleColor}/>}
                        {isTestingContract && <ListElem content='Login with your Mobile Number' rippleColor={rippleColor} onClick={() => openInputModal({
                            type: 'mobile',
                            key: empLogin ? "employeeMobileList" : "ownerMobileList"
                        })}/>}
                    </div> : null}
                    {(!isAutoLogin && emailIds.length && !empLogin) ? <div className={styles['block']}>
                        <div className={styles['heading']}>
                            <span className='icon-mailLg heading-icon'></span>
                            <span>EMAIL OTP TO</span>
                        </div>
                        <div className={styles['divider']+' '+styles['list-title-divider']}></div>
                        {emailIds.map((email, index) => (
                            <ListElem content={email} onClick={() => onItemClick({
                                type: 'email',
                                data: email, 
                                index, 
                                key: empLogin ? "employeeEmailList" : "ownerEmailList", 
                                companyName,
                                rippleColor: rippleColor
                            })} />
                        ))}
                        {isTestingContract && <ListElem content='Login with your Email' rippleColor={rippleColor} onClick={() => openInputModal({
                            type: 'email',
                            key: empLogin ? "employeeEmailList" : "ownerEmailList"
                        })}/>}
                    </div> : null}
                </div>
                {!mobileNos.length && initialized ? <MsgComp jdEmpPresent={jdEmpPresent}/> : null}
                </>: (!isAutoLogin && !hideView ? <div className = {'type-selection'}>
                    <Button size="lg"
                        className = {'action-btn'}
                        clickHandler = {() => {
                            updateTypeSelPage(false);
                            if(isMobile){
                                historyHandler.addBackHandler("user-login",closeUserLogin);
                                historyHandler.pushState(history, "user-login");
                            }
                        }}
                        >
                        I am a Business Owner
                    </Button>
                    {
                        jdEmpPresent ? 
                        <Button variant="default" size="lg" 
                            className = {'action-btn'}
                            clickHandler = {() => {
                                updateTypeSelPage(false);
                                loginAsEmp();
                            }}
                            >
                            I am Justdial Representative
                        </Button> : null
                    }
                </div> : null)}
                {/* {jdEmpPresent && !empLogin && <div className={styles['emp-login-btn']} onClick={loginAsEmp}>
                    <span className='icon-logOut login-icon'></span>
                    <span className='btn-text'>Login as Justdial respresentative</span>
                </div>} */}
                {empLogin && !verifyPg?
                    <>
                        <div className={styles['readonly-btn-holder']}>
                            <Button
                                className={styles['readonly-btn']}
                                clickHandler={openReadOnlyPage}
                                size="lg"
                            >
                                Open Catalogue in Read Only Mode
                    </Button>
                        </div>
                        <div className={styles['fake-div']}></div>
                    </> : null}
                {openModal ? <ModalComp {...modalProps}/> : null}
                {confirmModal ? <ConfirmModal {...confirmProps}/> : null}
            </div>
            {verifyPg ? <VerifyUser fromDiscount={selectTypeQuery.fromDiscount} fromInventory={selectTypeQuery.fromInventory} {...verifyPgProps}/> : null}
            {showMsg ? <MsgComp jdEmpPresent={jdEmpPresent} onHidden={() => setMsg(false)}/> : null}
        </>
	);
};

const mapStateToProps = state => {
	return {
        session: state.session,
        isMobile : state.deviceData.isMobile
	};
};

export default connect(mapStateToProps,{setLoggedUser,showToastMessage,toggleTab,setSession,hideProductEditSlider})(UserAuth);
